import { Directive, Output, inject } from '@angular/core'
import { FacilityContextService } from './facility-context.service'
import { Observable } from 'rxjs'
import { Facility } from '../../facilities/facility'

@Directive({
  selector: '[appFacilityContext]',
})
export class FacilityContextDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private mexusContext = inject(FacilityContextService)

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  @Output()
  public get facilityChange(): Observable<Facility> {
    return this.mexusContext.facility$
  }
}
